import { render } from "./LoginParts.vue?vue&type=template&id=c85d53f0"
import script from "./LoginParts.vue?vue&type=script&lang=js"
export * from "./LoginParts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__